import { css } from '@emotion/react';
import { Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  dialogRoot: css`
    z-index: 999;
  `,
  dialogHeader: css`
    flex-direction: column;
    align-items: center;
    gap: 12px;
  `,
  linkBadge: ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;

    background-color: ${theme.colors.secondary.emerald[10]};
    border-radius: 50%;
  `,
  dialogContent: css`
    width: 565px;
    gap: 12px;
  `,
  dialogBody: css`
    ul {
      margin: 2px 0 24px;
      padding-left: 22px;
    }
  `,
  dialogFooter: css`
    margin-top: 24px;
    justify-content: center;
  `,
  button: css`
    width: 403px;
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
